import React from "react";

const PortalSuccess: React.FC = () => {
  const user = JSON.parse(sessionStorage.getItem("hs_user") || "{}");
  const plan = JSON.parse(sessionStorage.getItem("hs_plan") || "{}");
  const routerIp = sessionStorage.getItem("hs_ip") || "10.5.50.1";

  return (
    <div className="text-center">
      <div className="mb-4 text-5xl">✅</div>
      <h2 className="text-2xl font-bold text-gray-800 mb-2">You are Active!</h2>

      <div className="bg-green-50 p-4 rounded-lg mb-6 text-left">
        <p>
          <strong>Plan:</strong> {plan.name}
        </p>
        <p>
          <strong>Time:</strong> {plan.duration_minutes} Minutes
        </p>
      </div>

      <p className="mb-4 text-gray-600">Click below to start browsing.</p>

      {/* FORM POST TO MIKROTIK ROUTER */}
      <form action={`http://${routerIp}/login`} method="POST">
        <input type="hidden" name="username" value={user.phone} />
        <input type="hidden" name="password" value={user.password} />
        <input type="hidden" name="dst" value="http://google.com" />

        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-3 rounded-lg font-bold text-lg shadow-lg hover:bg-blue-700 transition-all"
        >
          CONNECT TO INTERNET 🚀
        </button>
      </form>
    </div>
  );
};

export default PortalSuccess;
